import {
  sortAlphabetically,
  sortStagioni,
  sortCategorie,
  sortGironi,
  sortGiornate,
  sortNumeriGara,
  sortCodiceSocieta,
} from './sort-functions'
import { TESSERE } from '../settings/settings'

const getStagioni = campionati =>
  campionati
    ?.map(c => c.stagione)
    ?.filter((v, i, a) => a.indexOf(v) === i)
    ?.sort(sortStagioni) || []

const getCampionati = campionati => campionati?.map(c => c.codice) || []

const getCategorie = data =>
  data
    ?.map(x => x.categoria)
    ?.filter(Boolean)
    ?.filter((v, i, s) => s.indexOf(v) === i)
    ?.sort(sortCategorie) || []

const getGironi = (data, includeEmpty = false) =>
  data
    ?.map(x => x.girone)
    ?.filter(x => Boolean(x) || includeEmpty)
    ?.filter((v, i, s) => s.indexOf(v) === i)
    ?.sort(sortGironi) || []

const getTeams = (data, iscrizioniLight) =>
  data
    ?.map(x => {
      const ids = (x.squadraCasaID &&
        x.squadraTrasfertaID && [x.squadraCasaID, x.squadraTrasfertaID]) ||
        (x.squadre && x.squadre.map(s => s.squadraID)) || [x._id]
      return ids?.map(id => ({ id, girone: x.girone }))
    })
    ?.flat()
    ?.filter(Boolean)
    ?.filter(
      (v, i, s) =>
        s.findIndex(t => t.id === v.id && t.girone === v.girone) === i,
    )
    ?.map(t => {
      const tt = iscrizioniLight?.find(i => i.id === t.id)
      return { ...t, nome: tt?.nomeSquadra }
    })
    ?.sort(
      (a, b) =>
        sortGironi(a.girone, b.girone, -1) ||
        sortAlphabetically(a.nome, b.nome),
    ) || []

const getNumeriGara = data =>
  data
    ?.map(x => x.numeroGara)
    ?.filter(Boolean)
    ?.filter((v, i, s) => s.indexOf(v) === i)
    ?.sort(sortNumeriGara)
    ?.map(x => ({
      numeroGara: x,
      categoria: data?.find(d => d.numeroGara === x)?.categoria,
      girone: data?.find(d => d.numeroGara === x)?.girone,
    })) || []

const getProvvedimenti = () => [
  'risultati-mancanti',
  'risultati-ritardo',
  'referti-mancanti',
  'referti-ritardo',
]

const getArbitraggi = () => ['Tutte le gare', 'Con arbitro', 'Senza arbitro']

const getPeriodi = () => [
  'Passate',
  'Future',
  'Prossimi 10 giorni',
  'Prossimi 30 giorni',
  'Senza data',
]

const getRitardi = () => [
  'Meno di 10 giorni',
  '10-20 giorni',
  '20-30 giorni',
  '30-60 giorni',
  'Oltre 60 giorni',
]

const getGiornate = data =>
  data
    ?.map(x => x.giornata)
    ?.filter(Boolean)
    ?.filter((v, i, s) => s.indexOf(v) === i)
    ?.sort(sortGiornate) || []

const getCodiciSocieta = data =>
  data
    ?.map(x => x.codiceSocieta)
    ?.filter(Boolean)
    ?.filter((v, i, s) => s.indexOf(v) === i)
    ?.sort(sortCodiceSocieta) || []

const getTessere = () => TESSERE?.map(t => t.key)

export {
  getStagioni,
  getCampionati,
  getCategorie,
  getGironi,
  getTeams,
  getNumeriGara,
  getProvvedimenti,
  getArbitraggi,
  getPeriodi,
  getRitardi,
  getGiornate,
  getCodiciSocieta,
  getTessere,
}
